import { CalendarIcon } from '@heroicons/react/16/solid';
import moment, { Moment } from 'moment';
import { useWorkspaceContext } from '../../../../../../../providers/WorkspaceProvider/Workspace.context';

import { CalendarEventType } from '../../../../../Chat.enum';
import { tChatEvent } from '../../../../../Chat.types';
import { parseAgendaEventType } from '../AgendaAction.functions';
import './AgendaBubble.styles.scss';

export default function AgendaBubble(props: tChatEvent) {
  const esDate = (val: moment.MomentInput) => moment(val).locale('es');

  const { agendaEvent } = props;
  const { workspaceInfo } = useWorkspaceContext();
  const name = agendaEvent?.name || '';
  const note = agendaEvent?.note || '';
  const createdAt = esDate(props.createdAt);
  const createdAtDate = createdAt.format('DD/MM/YYYY');
  const createdAtTime = createdAt.format('h:mm A');
  const author = workspaceInfo?.users[agendaEvent?.createdBy ?? ''];
  const eventType = parseAgendaEventType(
    agendaEvent?.eventType || CalendarEventType.CALL,
  );

  let startDate: Moment | string = esDate(agendaEvent?.startDate);
  startDate = startDate.format('DD/MM/YYYY - h:mm A');
  const duration = agendaEvent?.duration || 0;
  const hasStateDeleted = props.agendaEvent?.state === 'STATE_DELETED';

  return (
    <div className="AgendaBubble">
      <h6 className="AgendaBubble__Title">
        <CalendarIcon className="w-6 h-6 mr-1" aria-hidden="true" />
        Evento {hasStateDeleted ? 'eliminado' : 'agendado'}
      </h6>

      {!hasStateDeleted && (
        <>
          <div className="AgendaBubble__Content">
            <p>
              <span className="AgendaBubble__Content__Label">Título: </span>
              {name}
            </p>

            <p>
              <span className="AgendaBubble__Content__Label">
                Tipo de evento:{' '}
              </span>
              {eventType}
            </p>

            <p>
              <span className="AgendaBubble__Content__Label">
                Fecha & Hora:{' '}
              </span>
              {startDate}
            </p>

            <p>
              <span className="AgendaBubble__Content__Label">Duración: </span>
              {duration} minutos
            </p>

            {note ? (
              <p>
                <span className="AgendaBubble__Content__Label">Nota: </span>
                {note}
              </p>
            ) : null}
          </div>

          <div className="AgendaBubble__Footer">
            <span className="AgendaBubble__Author">
              {author?.firstName} {author?.lastName}
            </span>{' '}
            | {createdAtDate} | {createdAtTime}
          </div>
        </>
      )}
    </div>
  );
}
